import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import VIdeoSupport from './VideoTutorialSupport/VIdeoSupport';

const TechnicalSupport = () => {
  return (
    <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 style={{ marginBottom: 30 }}>Apoyo Técnico</h3>
      </Col>
    </Row>
    <Row>
        <VIdeoSupport />
    </Row>
  </Container>
  )
}
export default TechnicalSupport